export default __webpack_public_path__ + "static/AppFace3-957ea98b4780d06e24fcda839dbe22b5.png";